import { Fraga } from "@/types/riskbedomning";

export type RiskPhase = "byggskede" | "bruksskede";

export const RISK_PHASE_LABEL: Record<RiskPhase, string> = {
  byggskede: "Utförande (byggskede)",
  bruksskede: "Bruksskede",
};

export const RISK_PHASE_SHORT_LABEL: Record<RiskPhase, string> = {
  byggskede: "Utförande",
  bruksskede: "Bruksskede",
};

export const RISK_PHASE_DOC_NUMBER: Record<RiskPhase, string> = {
  byggskede: "Dok 30b",
  bruksskede: "Dok 31",
};

export const RISK_PHASE_DESCRIPTION: Record<RiskPhase, string> = {
  byggskede:
    "Risker under byggskedet – arbetsmoment, etablering och produktion.",
  bruksskede:
    "Kvarstående risker vid drift, underhåll och användning av byggnadsverket.",
};

export const isRiskPhase = (value: unknown): value is RiskPhase =>
  value === "byggskede" || value === "bruksskede";

export const normalizeRiskPhase = (value: unknown): RiskPhase =>
  isRiskPhase(value) ? value : "byggskede";

/** Filter the question bank so a document only shows questions for its phase. */
export const filterFragorByPhase = (fragor: Fraga[], phase: RiskPhase): Fraga[] => {
  if (phase === "bruksskede") {
    return fragor.filter((f) => f.fas === "bruksskede");
  }
  return fragor.filter((f) => f.fas !== "bruksskede");
};
